<template>
    <div v-loading="$parentInfo.Dialog_SellSignature.loading" class="printOrder-data" >
        <vue-scroll :ops="$ops">
            <div class="noprint" v-show="$parentInfo.Dialog_SellSignature.printOn">
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">打印合同
                </el-button>
            </div>
            <div :style="{'height':$parentInfo.Dialog_SellSignature.maxHeight-45+'px'}" id="print">
                <div id="printArea"
                     class="printableArea"
                     v-if="$parentInfo.Dialog_SellSignature.showOn"
                     :class="{'ph':!$parentInfo.Dialog_SellSignature.printOn,'show':$parentInfo.Dialog_SellSignature.printOn}"
                     style=";position: relative;">

                    <div style="position: relative" class="invoice-body">
                        <div>
                            <div>
                                <h1 class="main_title">墨 帝 教 育</h1>

                            </div>
                            <div>
                                <h3 class="title">商品签收单</h3>
                            </div>
                            <div>
                                <p>收货方今现场查收以下商品：</p>
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th>名称</th>
                                            <th>序列号</th>
                                            <th>数量</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item,index) in receiveRecord.shopRecords" :key="index">
                                            <td>{{item.shop_name}}</td>
                                            <td>{{item.serial_id}}</td>
                                            <td>{{item.number}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div>
                                <p>备注：</p>
                                <p>1.请收货方验证商品后填写下栏，此签收单由墨帝教育收存；</p>
                                <p>2.本批次商品为编号为 <span style="text-decoration: underline"> {{receiveRecord.prefix}} </span>的《墨帝教育服务协议书》中所述教学设备。</p>
                            </div>

                            <div class="table-responsive" style="clear: both;">
                                <table class="table table-bordered">
                                    <tbody>
                                    <tr>
                                        <td rowspan="5" style="width: 100px;text-align: center;height:50px;line-height:50px;">钱 <br>收 <br>单</td>
                                    </tr>
                                    <tr>
                                        <td>以上货物已于________年________月________日清点验收，商品符合合同约定。</td>
                                    </tr>
                                    <tr>
                                        <td>学生姓名：</td>
                                    </tr>
                                    <tr>
                                        <td>收货人签名：</td>
                                    </tr>
                                    <tr>
                                        <td>收货人联系电话：</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div style="clear: both"></div>
                        </div>
                    </div>

                </div>
            </div>
        </vue-scroll>

    </div>
</template>
<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
    .show {
        overflow: auto;
    }

    .ph {
        height: 100% !important;
    }

    .printableArea {
        padding: 10px 20px;
        color: #000 !important;
        font-weight: 500;
    }

    .printableArea .invoiceNumber{
        position:absolute;right:30px;font-size:10px;color:rgba(120, 130, 140, 0.74);
    }
    .printableArea .title{
        margin-top: 0;line-height: 30px;font-size: 18px;font-weight: 500;text-align: center;
    }
    .printableArea .main_title{
        margin-top: 0;line-height: 30px;font-weight: 500;text-align: center;
    }
    .printableArea h3 {
        line-height: 30px;
        font-size: 15px;
        font-weight: 500;
    }

    .printableArea p {
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .printableArea table {
        font-size: 12px;
        border-color: #000;
    }

    .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
    .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
    .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
        border: 1px solid #000 !important;
        color: #000;
        font-size: 12px;
        font-weight: 500 !important;
    }

    .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
        padding: 7px 9px;
    }

    .printableArea .table-responsive {
        padding: 0 15px;
    }

    .printableArea .page-break{
        page-break-before: always  !important;
    }

    @media print{
        #print {
            .printableArea {
                padding: 0 !important;
                color: #000 !important;
                font-weight: 500;

            }

            .invoice-body{
                page-break-before:always;
            }

            .printableArea .title{
                margin-top: 0;
                line-height: 40px;
                font-size: 25px;
                font-weight: 500;
                text-align: center;

            }
            .printableArea .invoiceNumber{
                position:absolute;right:30px;font-size:15px;color:rgba(120, 130, 140, 0.74);
            }

            .printableArea h3 {
                line-height: 30px;
                font-size: 21px;
                font-weight: 500;
            }


            .printableArea p {
                font-size: 18px;
                padding-left: 15px;
                padding-right: 15px;
            }

            .printableArea table {
                font-size: 18px;
                border-color: #000;
            }

            .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
            .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
            .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
                border: 1px solid #000 !important;
                color: #000;
                font-size: 18px;
                font-weight: 500 !important;
            }

            .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
                padding: 7px 9px;
            }

            .printableArea .table-responsive {
                padding: 0 15px;
            }

            .printableArea .page-break{
                page-break-before: always  !important;
            }
        }
    }
</style>
<script>
    import store from '@/store'
    export default {
        name: 'Dialog_SellSignature',
        data() {
            return {
                invoiceItems:[],
                receiveRecord:[],
                id:1,
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handlePrintSignature()
        },
        methods: {
            handlePrintSignature(){
                this.$axios.post(store.state.server + '/printReceive',{
                    'invoiceId':this.$store.state.modal.data.invoiceId
                }).then((response) => {
                    if (response.data.code == '0000') {
                        this.receiveRecord=response.data.content.receiveRecord;
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            modelClose() {
                ipc.send('invoiceDetailClose');
            },

        }
    };
</script>
